export class FetchCountries {
  static readonly type = '[Country] Fetch countries';
  constructor(public refetchIfAlreadyFetched: boolean = true) {}
}
